import { InputMultiSelectControl, MultiSelect } from '../../Select'
import { toUserSelectItems } from '../User.utils'
import { UserSelect } from '../UserSelect'

function UserMultiSelect({
  Control = InputMultiSelectControl,
  getTagText,
  tagsProps,
  toPreparedItems = toUserSelectItems,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      Select={UserSelect}
      tagsProps={{
        ...tagsProps,
        getText: getTagText,
        onChange: onSelectItem,
        onClear,
      }}
      toPreparedItems={toPreparedItems}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default UserMultiSelect
